import { API, graphqlOperation } from "aws-amplify";
import {
  dataJacketList,
  dataJacket,
  dataJacketIDs,
  dataset,
  dataRecord,
  nodeInfo,
  statistics,
  rawData,
  fileHeader,
  fileHeaderIDs,
  fileHeaderItems,
  saveUserDataNetwork,
  getUserDataNetwork,
  announcementAcquisition,
  datajacketImageAcquisition,
  countDataTable,
  countRawData,
  myDataJacketgetUserId,
  myDataJacketList,
  myDataJacketsortOrderList,
  myDataJacketGetImage,
  myConnectDJgetUserId,
  myConnectDJList,
  myConnectDJsortOrderList,
  favoriteRegistrationRelease,
  myDataJacketDelete,
  myConnectDJDelete,
  myCoonectDJtGetImage,
  myConnectDJInsert,
  myConnectDJUpdate,
  myConnectDJGetUserDataNetwork,
  myConnectDJInsertSave,
  myConnectDJGetUserDataNetworkSave,
  myConnectDJUpdateName,
  myDataJacketUpdateName,
  myConnectDJReturnId,
  myConnectDJReturnName,
  myDataJacketReturnId,
  myDataJacketReturnName,
} from "../graphql/queries";
import {
  truncateStringWithEllipsis,
  convertDateTimeToDate,
  convertDateTimeToDateTime,
} from "../js/stringHandling";

export async function DataJacketIDList(
  pages,
  inPrice,
  user,
  bookmarked,
  inRelatedIndustry,
  inKeyword,
  inSortOrder
) {
  let numOfLimit = 12;
  let numOfOffset = (pages - 1) * 12;
  let strPrice = "";
  let strRelatedIndustry = "";
  let strSortOrder = "";
  let strKeyword = "";
  if (pages === 0) {
    numOfLimit = 1000000;
    numOfOffset = 0;
  }
  if (undefined !== inKeyword) strKeyword = inKeyword;
  if (undefined !== inPrice) strPrice = inPrice;
  if (undefined !== inRelatedIndustry && "未指定" !== inRelatedIndustry)
    strRelatedIndustry = inRelatedIndustry;

  if (undefined !== inSortOrder && "未指定" !== inSortOrder)
    strSortOrder = inSortOrder;

  const resultIds = API.graphql(
    graphqlOperation(dataJacketIDs, {
      limit: numOfLimit,
      offset: numOfOffset,
      price: strPrice,
      user: user,
      bookmarked: bookmarked,
      relatedIndustry: strRelatedIndustry,
      keyword: strKeyword,
      sortOrder: strSortOrder,
    })
  ).then((evt) => {
    return evt.data.dataJacketIDs.ids.split(",");
  });
  return resultIds;
}

export async function getDataSetDetail(inDataSetId) {
  const result = API.graphql(graphqlOperation(dataset, { id: inDataSetId }))
    .then((evt) => {
      //Change DateTime Format before assign
      evt.data.dataset.body.created_date = convertDateTimeToDateTime(
        evt.data.dataset.body.created_date
      );
      evt.data.dataset.body.update_date = convertDateTimeToDateTime(
        evt.data.dataset.body.update_date
      );
      return evt.data.dataset.body;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getDataRecordDetail(inDataRecordId) {
  const result = API.graphql(
    graphqlOperation(dataRecord, { id: inDataRecordId })
  )
    .then((evt) => {
      //Change DateTime Format before assign
      evt.data.dataRecord.body.registration_date = convertDateTimeToDate(
        evt.data.dataRecord.body.registration_date
      );
      evt.data.dataRecord.body.information_update_modification_date =
        convertDateTimeToDate(
          evt.data.dataRecord.body.information_update_modification_date
        );
      return evt.data.dataRecord.body;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getAllDataJacketDetails(inDataJacket, userId) {
  const returnComp = [];
  await inDataJacket.reduce(async (promise, item) => {
    await promise;
    const result = await API.graphql(
      graphqlOperation(dataJacket, { id: item, userId: userId })
    ).then((evt) => {
      try {
        evt.data.dataJacket.body.data_jacket_date_published =
          convertDateTimeToDate(
            evt.data.dataJacket.body.data_jacket_date_published
          );
        evt.data.dataJacket.body.data_jacket_date_update =
          convertDateTimeToDate(
            evt.data.dataJacket.body.data_jacket_date_update
          );

        evt.data.dataJacket.body.data_jacket_summary =
          truncateStringWithEllipsis(
            evt.data.dataJacket.body.data_jacket_summary,
            174
          );
        evt.data.dataJacket.body.data_jacket_name = truncateStringWithEllipsis(
          evt.data.dataJacket.body.data_jacket_name,
          50
        );

        // お気に入り登録済みの場合user_favorite_flagがtrueになるが、falseが登録済みを意味するので反転させる
        evt.data.dataJacket.body.user_favorite_flag =
          !evt.data.dataJacket.body.user_favorite_flag;
        returnComp.push({
          key: item,
          jacketId: item,
          datajacket: evt.data.dataJacket.body,
        });
      } catch (e) {}
    });
  });
  return returnComp;
}

export async function MyDataJacketIDList(pages, user, inSortOrder) {
  let numOfLimit = 12;
  let numOfOffset = (pages - 1) * 12;
  let strSortOrder = "";
  if (pages === 0) {
    numOfLimit = 1000000;
    numOfOffset = 0;
  }
  if (undefined !== inSortOrder && "未指定" !== inSortOrder)
    strSortOrder = inSortOrder;

  const resultIds = API.graphql(
    graphqlOperation(myDataJacketsortOrderList, {
      userId: user,
      sortOrder: strSortOrder,
      limit: numOfLimit,
      offset: numOfOffset,
    })
  ).then((evt) => {
    return evt.data.myDataJacketsortOrderList.body.ids.split(",");
  });
  return resultIds;
}

export async function MyConnectDJIDList(pages, user, inSortOrder) {
  let numOfLimit = 12;
  let numOfOffset = (pages - 1) * 12;
  let strSortOrder = "";
  if (pages === 0) {
    numOfLimit = 1000000;
    numOfOffset = 0;
  }
  if (undefined !== inSortOrder && "未指定" !== inSortOrder)
    strSortOrder = inSortOrder;

  const resultIds = API.graphql(
    graphqlOperation(myConnectDJsortOrderList, {
      userId: user,
      sortOrder: strSortOrder,
      limit: numOfLimit,
      offset: numOfOffset,
    })
  ).then((evt) => {
    return evt.data.myConnectDJsortOrderList.body.ids.split(",");
  });
  return resultIds;
}

export async function getFavoriteIds(user) {
  const resultIds = API.graphql(
    graphqlOperation(myDataJacketgetUserId, { userId: user })
  )
    .then((evt) => {
      return evt.data.myDataJacketgetUserId.body.id.split(",");
    })
    .catch((evt) => {
      return "";
    });
  return resultIds;
}

export async function getFavoriteConnectIds(user) {
  const resultIds = API.graphql(
    graphqlOperation(myConnectDJgetUserId, { userId: user })
  )
    .then((evt) => {
      return evt.data.myConnectDJgetUserId.body.ids.split(",");
    })
    .catch((evt) => {
      return "";
    });
  return resultIds;
}

export async function getFavoriteAllDataJacket(inDataJacket) {
  const returnComp = [];
  await inDataJacket.reduce(async (promise, item) => {
    await promise;
    await API.graphql(
      graphqlOperation(myDataJacketList, { myDataJacketId: item })
    ).then((evt) => {
      try {
        evt.data.myDataJacketList.body.created_date = convertDateTimeToDate(
          evt.data.myDataJacketList.body.created_date
        );

        evt.data.myDataJacketList.body.data_jacket_summary =
          truncateStringWithEllipsis(
            evt.data.myDataJacketList.body.data_jacket_summary,
            174
          );
        evt.data.myDataJacketList.body.data_jacket_name =
          truncateStringWithEllipsis(
            evt.data.myDataJacketList.body.data_jacket_name,
            50
          );
        returnComp.push({
          key: item,
          jacketId: item,
          myDataJacketList: evt.data.myDataJacketList.body,
        });
      } catch (e) {}
    });
  });

  return returnComp;
}

export async function getFavoriteAllConnectDj(inDataJacket) {
  const returnComp = [];
  await inDataJacket.reduce(async (promise, item) => {
    await promise;
    await API.graphql(
      graphqlOperation(myConnectDJList, { myConnectDJId: item })
    ).then((evt) => {
      try {
        evt.data.myConnectDJList.body.created_date = convertDateTimeToDate(
          evt.data.myConnectDJList.body.created_date
        );

        evt.data.myConnectDJList.body.connect_dj_summary =
          truncateStringWithEllipsis(
            evt.data.myConnectDJList.body.connect_dj_summary,
            174
          );
        evt.data.myConnectDJList.body.connect_dj_name =
          truncateStringWithEllipsis(
            evt.data.myConnectDJList.body.connect_dj_name,
            50
          );
        returnComp.push({
          key: item,
          jacketId: item,
          myConnectDJList: evt.data.myConnectDJList.body,
        });
      } catch (e) {}
    });
  });

  return returnComp;
}

export async function getMyDataJacket(inMyDataJacketId) {
  const resultIds = API.graphql(
    graphqlOperation(myDataJacketList, { myDataJacketId: inMyDataJacketId })
  )
    .then((evt) => {
      return evt.data.myDataJacketList.body;
    })
    .catch((evt) => {
      return "";
    });
  return resultIds;
}

export async function getMyConnectDj(inMyConnectDJId) {
  const resultIds = API.graphql(
    graphqlOperation(myConnectDJList, { myConnectDJId: inMyConnectDJId })
  )
    .then((evt) => {
      return evt.data.myConnectDJList.body;
    })
    .catch((evt) => {
      return "";
    });
  return resultIds;
}

export async function FileHeaderIDList(inDataSetId) {
  const resultIds = API.graphql(
    graphqlOperation(fileHeaderIDs, { id: inDataSetId })
  )
    .then((evt) => {
      return evt.data.fileHeaderIDs.ids.split(",");
    })
    .catch((evt) => {
      return "";
    });
  return resultIds;
}

export async function getFullDataJacketList(userNameId) {
  const resultIds = API.graphql(
    graphqlOperation(dataJacketList, { userId: userNameId })
  )
    .then((evt) => {
      return evt.data.dataJacketList.body;
    })
    .catch((evt) => {
      return "";
    });
  return resultIds;
}

export async function getFileHeaderDetail(inFileHeaderId) {
  const result = API.graphql(
    graphqlOperation(fileHeader, { id: inFileHeaderId })
  )
    .then((evt) => {
      return evt.data.fileHeader.body;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function announce() {
  const result = API.graphql(graphqlOperation(announcementAcquisition, {}))
    .then((evt) => {
      return evt.data.announcementAcquisition.body.text;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getNumberOfDataTables() {
  const result = API.graphql(graphqlOperation(countDataTable, {}))
    .then((evt) => {
      return evt.data.countDataTable.count;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getNumberOfDataRecords() {
  const result = API.graphql(graphqlOperation(countRawData, {}))
    .then((evt) => {
      return evt.data.countRawData.count;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getDataJacketNodeDetail(inDataJacketId, userName) {
  const result = API.graphql(
    graphqlOperation(nodeInfo, { id: inDataJacketId, userId: userName })
  )
    .then((evt) => {
      return evt.data.nodeInfo.body;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function FileHeaderItems(inFileHeaderId, inDataSetId) {
  const returnComp = [];
  await inFileHeaderId.reduce(async (promise, item) => {
    await promise;
    const result = await API.graphql(
      graphqlOperation(fileHeader, { id: item, subid: inDataSetId })
    ).then((evt) => {
      returnComp.push({
        name: evt.data.fileHeader.body.item_name,
        description: evt.data.fileHeader.body.item_description,
      });
    });
  });
  return returnComp;
}

export async function getStatisticsDetail(inDataSetId) {
  const result = API.graphql(graphqlOperation(statistics, { id: inDataSetId }))
    .then((evt) => {
      return evt.data.statistics;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getRawDataDetail(inDataSetId) {
  const result = API.graphql(graphqlOperation(rawData, { id: inDataSetId }))
    .then((evt) => {
      return evt.data.rawData;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getFileHeaderItems(inDataSetId) {
  const result = API.graphql(
    graphqlOperation(fileHeaderItems, { id: inDataSetId })
  )
    .then((evt) => {
      return evt.data.fileHeaderItems.body;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function saveDataNetwork(
  inUserId,
  inNetworkName,
  inNetworkId,
  inCommand,
  inJson
) {
  const result = API.graphql(
    graphqlOperation(saveUserDataNetwork, {
      userId: inUserId,
      networkName: inNetworkName,
      networkId: inNetworkId,
      command: inCommand,
      json: inJson,
    })
  )
    .then((evt) => {
      return "complete";
    })
    .catch((evt) => {
      return "error";
    });
  return result;
}

export async function saveDataNetwork2(
  inUserId,
  injsonFiltered,
  injsonSimilarity,
  inJsonAll
) {
  const result = API.graphql(
    graphqlOperation(myConnectDJInsertSave, {
      userId: inUserId,
      jsonFiltered: injsonFiltered,
      jsonSimilarity: injsonSimilarity,
      jsonAll: inJsonAll,
    })
  )
    .then((evt) => {
      return "complete";
    })
    .catch((evt) => {
      return "error";
    });
  return result;
}

export async function StoreInDataNetwork(
  inUserId,
  inDJImage,
  inDJName,
  inDJSummary,
  inJsonFiltered,
  injsonSimilarity,
  injsonAll
) {
  const result = API.graphql(
    graphqlOperation(myConnectDJInsert, {
      userId: inUserId,
      connectDJImage: inDJImage,
      connectDJName: inDJName,
      connectDJSummary: inDJSummary,
      jsonFiltered: inJsonFiltered,
      jsonSimilarity: injsonSimilarity,
      jsonAll: injsonAll,
    })
  )
    .then((evt) => {
      return evt.data.myConnectDJInsert.body.my_connect_dj_id;
    })
    .catch((evt) => {
      return "error";
    });
  return result;
}

export async function StoreInUpdateDataNetwork(
  inConnectDJId,
  inDJImage,
  inDJName,
  inDJSummary,
  inJsonFiltered,
  injsonSimilarity,
  injsonAll
) {
  const result = API.graphql(
    graphqlOperation(myConnectDJUpdate, {
      myConnectDJId: inConnectDJId,
      connectDJImage: inDJImage,
      connectDJName: inDJName,
      connectDJSummary: inDJSummary,
      jsonFiltered: inJsonFiltered,
      jsonSimilarity: injsonSimilarity,
      jsonAll: injsonAll,
    })
  )
    .then((evt) => {
      return evt.data.myConnectDJUpdate.body.my_connect_dj_id;
    })
    .catch((evt) => {
      return "error";
    });
  return result;
}

export async function getDataNetwork(inUserId) {
  const result = API.graphql(
    graphqlOperation(getUserDataNetwork, { userId: inUserId })
  )
    .then((evt) => {
      return evt.data.getUserDataNetwork.json;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getDataNetwork2(inUserId) {
  const result = API.graphql(
    graphqlOperation(myConnectDJGetUserDataNetworkSave, { userId: inUserId })
  )
    .then((evt) => {
      return evt.data.myConnectDJGetUserDataNetworkSave.body;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getSavedDataNetwork(InmyConnectDJId) {
  const result = API.graphql(
    graphqlOperation(myConnectDJGetUserDataNetwork, {
      myConnectDJId: InmyConnectDJId,
    })
  )
    .then((evt) => {
      return evt.data.myConnectDJGetUserDataNetwork.body;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getDataJacketImage(inDataJacketId) {
  const result = API.graphql(
    graphqlOperation(datajacketImageAcquisition, {
      datajacketId: inDataJacketId,
    })
  )
    .then((evt) => {
      return evt.data.datajacketImageAcquisition.body.img;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function myImage(inDataJacketId) {
  const result = API.graphql(
    graphqlOperation(myDataJacketGetImage, {
      myDataJacketId: inDataJacketId,
    })
  )
    .then((evt) => {
      return evt.data.myDataJacketGetImage.body.img;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}
export async function favoriteChange(inUserId, inDataJacketId, inFlag) {
  const result = API.graphql(
    graphqlOperation(favoriteRegistrationRelease, {
      userId: inUserId,
      dataJacketId: inDataJacketId,
      favoriteFlag: inFlag,
    })
  )
    .then((evt) => {
      return inDataJacketId + inFlag;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function deleteMyDataJacket(inMyDataJacketId) {
  const result = API.graphql(
    graphqlOperation(myDataJacketDelete, { myDataJacketId: inMyDataJacketId })
  )
    .then((evt) => {
      return evt.data.myDataJacketDelete.body.result;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function deleteMyConnectDj(inMyConnectDJId) {
  const result = API.graphql(
    graphqlOperation(myConnectDJDelete, { myConnectDJId: inMyConnectDJId })
  )
    .then((evt) => {
      return evt.data.myConnectDJDelete.body.result;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function myConnectImage(inConnectDJId) {
  const result = API.graphql(
    graphqlOperation(myCoonectDJtGetImage, {
      myConnectDJId: inConnectDJId,
    })
  )
    .then((evt) => {
      return evt.data.myCoonectDJtGetImage.body.img;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}
export async function renameMyConnectDj(inMyConnectDJId, inConnectDJName) {
  const result = API.graphql(
    graphqlOperation(myConnectDJUpdateName, {
      myConnectDJId: inMyConnectDJId,
      connectDJName: inConnectDJName,
    })
  )
    .then((evt) => {
      return evt;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function renameMyDataJacket(inMyDataJacketId, inDataJacketName) {
  const result = API.graphql(
    graphqlOperation(myDataJacketUpdateName, {
      myDataJacketId: inMyDataJacketId,
      dataJacketName: inDataJacketName,
    })
  )
    .then((evt) => {
      return evt;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getMyConnectDJId(inUserId, inConnectDJName) {
  const result = API.graphql(
    graphqlOperation(myConnectDJReturnId, {
      userId: inUserId,
      connectDJName: inConnectDJName,
    })
  )
    .then((evt) => {
      return evt.data.myConnectDJReturnId.body.my_connect_dj_id;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getMyConnectDJName(inUserId) {
  const result = API.graphql(
    graphqlOperation(myConnectDJReturnName, {
      userId: inUserId,
    })
  )
    .then((evt) => {
      return evt.data.myConnectDJReturnName.body.my_connect_dj_name;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getMyDataJacketId(inUserId, inConnectDataJacketName) {
  const result = API.graphql(
    graphqlOperation(myDataJacketReturnId, {
      userId: inUserId,
      dataJacketName: inConnectDataJacketName,
    })
  )
    .then((evt) => {
      return evt.data.myDataJacketReturnId.body.my_data_jacket_id;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}

export async function getMyDataJacketName(inUserId) {
  const result = API.graphql(
    graphqlOperation(myDataJacketReturnName, {
      userId: inUserId,
    })
  )
    .then((evt) => {
      return evt.data.myDataJacketReturnName.body.my_data_jacket_name;
    })
    .catch((evt) => {
      return "";
    });
  return result;
}
